/**
 * The console has one address: `admin.bookmypandiit.com`.
 *
 * Cloudflare Pages also serves every project on a `*.pages.dev` alias, and that alias is a second
 * front door nobody chose — it is guessable, it is indexed by anyone who looks at certificate
 * transparency logs, and it bypasses anything applied to the custom domain.
 *
 * **This is a redirect, not a control.** It runs in the visitor's browser, so anyone who wants the
 * alias can have it — devtools, `curl`, or simply reading the bundle. What it buys is that the
 * alias stops being a *usable* console for someone who lands on it, and that links people share
 * are the canonical ones. The control is Cloudflare Access in front of the alias; this is the part
 * that does not need a dashboard.
 *
 * Preview deployments (`<hash>.bookmypandiit-admin.pages.dev`) are deliberately left alone —
 * reviewing a build is exactly what they are for, and sending them to production would defeat it.
 */
export const CANONICAL_HOST = 'admin.bookmypandiit.com';
/** The public website, which the console links to and never serves. */
export const PUBLIC_SITE_ORIGIN = 'https://bookmypandiit.com';
const ALIAS = 'bookmypandiit-admin.pages.dev';

/** Where this location should have been, or `null` if it is already somewhere sensible. */
export function canonicalUrl(location: Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash'>): string | null {
  if (location.hostname !== ALIAS) return null;
  return `https://${CANONICAL_HOST}${location.pathname}${location.search}${location.hash}`;
}
